export function containsHighlyConfidentialInfo(fields: string[], regex: RegExp): boolean {
  return fields.some((field) => regex.test(field));
}

export async function fetchHighlyConfidentialRegex(): Promise<RegExp> {
  // Hardcoded regex for confidentiality check
  return /ningbo/i;
}
